export default {"src":"/_next/static/media/TableclothLogo.1faa9e23.svg","height":76,"width":202,"blurWidth":0,"blurHeight":0};